import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroupText,
  InputGroup,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import profile from "assets/images/logo_transparent.png"
import logo from "assets/images/logo.svg"

import "../../assets/css/Login/Login.css"
import Configs from "../../config"
import secureLocalStorage from "react-secure-storage"
import { FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"
import { IoMdEye, IoMdEyeOff } from "react-icons/io"

const Login = () => {
  const navigate = useNavigate()
  document.title = "Login | Fans to 5K"

  // ------------------ STATES -------------------
  const [rememberMe, setRememberMe] = useState(false)

  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  })

  useEffect(() => {
    const savedCreds = secureLocalStorage.getItem("remember_credentials")

    if (savedCreds) {
      setFormData({
        email: savedCreds.email || "",
        password: savedCreds.password || "",
      })
      setRememberMe(true)
    }
  }, [])

  const [errors, setErrors] = useState({})

  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = () => {
    setShowPassword(prev => !prev)
  }

  // ------------------ HANDLERS -------------------
  const handleChange = e => {
    const { name, value } = e.target

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const validate = () => {
    const errs = {}
    if (!formData.email) {
      errs.email = "Email is required"
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errs.email = "Invalid email format"
    }

    if (!formData.password) {
      errs.password = "Password is required"
    } else if (formData.password.length < 6) {
      errs.password = "Password must be at least 6 characters"
    }

    return errs
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const validationErrors = validate()
    console.log(validationErrors)
    setErrors(validationErrors)

    const APIData = await FetchPostData(
      setLoading,
      "auth/staff/login",
      formData
    )

    if (APIData?.data?.success) {
      Swal.fire({
        title: "Login Successfull",
        text: APIData?.data?.message,
        icon: "success",
        timer: 1000,
      })

      if (rememberMe) {
        secureLocalStorage.setItem("remember_credentials", {
          email: formData.email,
          password: formData.password,
        })
      } else {
        secureLocalStorage.removeItem("remember_credentials")
      }

      secureLocalStorage?.setItem("admin_user", APIData?.data?.staff)
      secureLocalStorage?.setItem("auth_token", APIData?.data?.token)
      navigate(`${Configs.appurl}dashboard`)
    } else {
      Swal.fire({
        title: "Login Unsuccessfull",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="login-page">
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft pe-3">
                    <Row>
                      <Col xs={8}>
                        <div className="text-black p-4">
                          <h5 className="text-primary">Welcome Back!</h5>
                          <p>Sign in to continue to Fans to 5K.</p>
                        </div>
                      </Col>
                      <Col className="col-4 align-self-center">
                        <img
                          src={profile}
                          alt="Login Illustration"
                          className="img-fluid bg-dark"
                        />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="text-center">
                      <Link
                        to={`${Configs.appurl}`}
                        className="logo-light-element"
                      >
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt="Logo"
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>

                    <div className="p-2">
                      <Form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <Label className="form-label">
                            Email <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="email"
                            type="email"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.email && (
                            <span className="text-danger">{errors.email}</span>
                          )}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">
                            Password <span className="text-danger">*</span>
                          </Label>
                          <InputGroup>
                            <Input
                              name="password"
                              type={showPassword ? "text" : "password"}
                              placeholder="Enter password"
                              value={formData.password}
                              onChange={handleChange}
                            />
                            <InputGroupText
                              style={{ cursor: "pointer" }}
                              onClick={togglePassword}
                              className="bg-white"
                            >
                              {showPassword ? (
                                <IoMdEyeOff size={18} />
                              ) : (
                                <IoMdEye size={18} />
                              )}
                            </InputGroupText>
                          </InputGroup>
                          {errors.password && (
                            <span className="text-danger">
                              {errors.password}
                            </span>
                          )}
                        </div>

                        <div className="form-check mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="remember"
                            checked={rememberMe}
                            onChange={e => setRememberMe(e.target.checked)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="remember"
                          >
                            Remember me
                          </label>
                        </div>

                        <div className="mt-3 d-grid">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                          >
                            Log In
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

Login.propTypes = {
  history: PropTypes.object,
}

export default Login
